import { Component, Input, OnChanges } from '@angular/core'

import { ActivatedRoute, Router } from '@angular/router'
import { Project, Account } from '4d-mapper'
import { Subscription, combineLatest } from 'rxjs'
import { Location } from '@angular/common'
import { TranslateService } from '@ngx-translate/core'
import { LoadingSpinner } from '../commons/ui/loading-spinner'
import { FileDataService, FileUpload, TaskProcessing } from '../v2/commons/file-data.service'

@Component({
    selector:'app-root-comp',
    template:`<div style="height:100%;height:100vh;width:100vw;margin:0;padding:0;border:solid 2px red;"><home-comp [config]="config"></home-comp></div>`
})
export class AppBaseComponent{

    projects:Project[] = []
    team:Account
    teams:Account[] = []

    processing:TaskProcessing[] = []
    uploads:FileUpload[] = []

    private _subs:Subscription[] = []

    config:any = {
        panels:[
            {
                id: 'app', 
                dock:'top left right bottom',
                height: 'full',
                header: { 
                    id:'navbar', 
                    dock: 'top left right', 
                    height:50, 
                    items:[
                        { id:'logo', dock: 'left'}, { id:'burger', dock: 'left'}, { id:'team', dock: 'left'}, 
                        { id:'profile', dock:'right' }, { id:'config', dock: 'right'}, { id:'help', dock: 'right'}, 
                    ] },
                content: { 
                    id:'map', 
                    dock: 'top bottom left right',
                    height: 'full',
                    items: [
                        { id:'sidenav', dock:'left' }
                    ]
                }
            }
        ]
    };

    constructor(private fileManager:FileDataService,  private route:ActivatedRoute, private router:Router, private location:Location, public translate: TranslateService ) {

    }

    ngOnInit(){

        LoadingSpinner.end();

        this.fileManager.init().subscribe()

        combineLatest(this.fileManager.onReady(),this.route.params).subscribe(([_,params]) => {

            console.log('TEAMS',params);

            // listen to param changes
            if(params.team){
                var team = this.fileManager.teams.values.find(t => t.uid == params.team)
                if(team)
                    // this will trigger everyone else
                    this.fileManager.initTeam(team).subscribe()
                else
                    throw new Error("Invalid team for this account " + params.team)
            }
    
        })
        
        this._subs.push(this.fileManager.processingItems.state.subscribe(s => this.processing = s))
        this._subs.push(this.fileManager.uploadingFiles.state.subscribe(s => this.uploads = s))
        this._subs.push(this.fileManager.uploadingQueue.state.subscribe(s => this.uploads = s))
        
        this._subs.push(this.fileManager.projects.state.subscribe(s => this.projects = s))
        this._subs.push(this.fileManager.teams.state.subscribe(s => this.teams = s))
        this._subs.push(this.fileManager.team.events.subscribe(s => {
            if(s.event == 'ADD'){
            this.team = s.item
            var path = this.router.url
            if(path.indexOf('?') != -1) path= path .substring(0,path.indexOf('?'))
            var v = path.split('/')
            v[0] = '/' + v[0]

            // if teams changed, redirect to same place on new team
            if(v[2] != s.item.uid){
                v[2] = s.item.uid
                this.router.navigate(v)
            }
            
            }
            else if(s.event == 'REMOVE'){
                this.team = null
            }
        }))
        
    }  


    ngOnDestroy(){
        this._subs.forEach(s => s.unsubscribe())
    }

    setTeam(uid:string){
        this.fileManager.initTeam(this.fileManager.teams.values.find(t => t.uid == uid)).subscribe()
    }
    goto(url:string[]){
        this.router.navigate(url,{relativeTo:this.route})
    }
}


@Component({
    selector:'home-comp',
    template:`<ng-container *ngIf="config">
        <xs-panel [config]="config"></xs-panel>
    </ng-container>`
})
export class HomeComponent implements OnChanges {
    
    @Input()
    config:any = null;

    ngOnChanges() {}
}



@Component({
    selector:'xs-panel',
    template:`<ng-container *ngIf="config && config.panels">
        <div *ngFor="let panel of config.panels" [id]="panel.id" [class]="'xsPanel '+panel.dock+ panel.height?'height-'+panel.height:''">
            <xs-debug label="panel"  [item]="panel"></xs-debug>
            <ng-container *ngIf="panel.header">
                <div [class]="'row header ' + (panel.header.height?'height-'+panel.header.height:'')">
                    <xs-debug label="header" [item]="panel.header"></xs-debug>
                    <ng-container *ngIf="panel.header.items">
                        <xs-panel-items [config]="panel.header"></xs-panel-items>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="panel.content">
                <div [class]="'row content ' + (panel.content.height?'height-'+panel.content.height:'')">
                    <xs-debug label="content" [item]="panel.content"></xs-debug>
                    <ng-container *ngIf="panel.content.items">
                        <xs-panel-items [config]="panel.content"></xs-panel-items>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="panel.panels">
                <xs-panel [config]="panel"></xs-panel>
            </ng-container>
        </div>
    </ng-container>`
})
export class XsPanelComponent implements OnChanges {
    
    @Input()
    config:any = null;

    ngOnChanges() {}
}


@Component({
    selector:'xs-panel-items',
    template:`<ng-container *ngIf="config && config.items">
    
        
        <table class="xsPanelItems">
            <!-- <tr><th colspan="3"> <xs-debug label="items" [item]="config"></xs-debug> </th></tr> -->
            <tr>
                <td *ngIf="left" class="left">
                    <ng-container *ngFor="let item of left">
                        [{{ item.id }}]
                    </ng-container>
                </td>
                <td *ngIf="center" class="center">c
                    <ng-container *ngFor="let item of center">
                        [{{ item.id }}]
                    </ng-container>
                </td>
                <td *ngIf="right" class="right">r
                    <ng-container *ngFor="let item of right">
                        [{{ item.id }}]
                    </ng-container>
                </td>
            </tr>
        </table>
    </ng-container>`
})
export class XsPanelItemsComponent implements OnChanges {
    
    @Input()
    config:any = null;

    left:any[] = null;
    center:any[] = null;
    right:any[] = null;
    
    ngOnChanges() {
        if ( this.config && this.config.items ) {
            this.config.items.forEach ( item => {
                if ( item.dock.indexOf('right') !== -1 ) {
                    if ( !this.right ) { this.right = []; }
                    this.right.push(item);
                } else if ( item.dock.indexOf('center') !== -1 ) {
                    if ( !this.center ) { this.center = []; }
                    this.center.push(item);
                } else {
                    if ( !this.left ) { this.left = []; }
                    this.left.push(item);
                }
            });
        }
        if ( this.right ) {
            this.right.reverse();
        }
    }
}

@Component({
    selector:'xs-debug',
    template:`<ng-container *ngIf="item && item.id">
        <div style="position:absolute;width:auto;height:20px;font-size:12px;text-align:center;padding:3px;background-color:#555;color:#fff;">
            <span style="color:yellow;font-size:9px;">{{ label }}</span> {{ item.id }}
        </div>
    </ng-container>`
})
export class XsDebugComponent implements OnChanges {
    
    @Input()
    item:any = null;

    @Input()
    label:any = null;

    ngOnChanges() {
    }
}